import { Accordion as BaseAccordion, type IAccordionProps } from "@reapptor-apps/reapptor-react-components";
import styles from "./AccordionWithSubheading.module.scss"

interface CustomAccordionProps extends IAccordionProps {
    subheading?: string | null;
    wrapperClassName?: string;
    subheadingClassName?: string;
}

/** 
 * Reapptor Accordion component with an optional subheading displayed above it.
 */
export const AccordionWithSubheading = ({ children, subheading, subheadingClassName, wrapperClassName, ...props }: CustomAccordionProps) => (
    <div className={wrapperClassName}>
        {subheading ? (
            <div className={subheadingClassName ?? styles.subheadingDefault}>{subheading}</div>
        ) : null}
        <BaseAccordion {...props}>
            {children}
        </BaseAccordion>
    </div>
);